<template>
  <div>
    <!-- 相关信息 -->
    <h3>
      {{ $t('message.relatedInformation') }}
    </h3>
    <div class="relatedInformation">
      <!-- 进行中订单 -->
      <router-link :to="'/underwayOrder?user_id=' + this.user_id" target="_blank">
        <div class="item">
          <div class="content">
            <div class="name"> {{ $t('message.orderInProgress') }}</div>
            <div class="num">{{ statsData.orderCount }}{{ $t('message.strip') }}</div>
          </div>
        </div>
      </router-link>
      <!-- 进行中配送单 -->
      <router-link :to="'/underwayPorder?user_id=' + this.user_id" target="_blank">
        <div class="item">
          <div class="content">
            <div class="name">{{ $t('message.deliveryOrderInProgress') }}</div>
            <div class="num">{{ statsData.porderCount }}{{ $t('message.strip') }}</div>
          </div>
        </div>
      </router-link>
      <!-- 仓库商品 -->
      <router-link :to="'/inventoryDetails?user_id=' + this.user_id" target="_blank">
        <div class="item">
          <div class="content">
            <div class="name">{{ $t('message.warehouseGoods') }}</div>
            <div class="num">{{ statsData.warehouseCount }}{{ $t('message.strip') }}</div>
          </div>
        </div>
      </router-link>
      <!-- 国内派送中 -->
      <router-link :to="'/productFollowUpPage?user_id=' + this.user_id" target="_blank">
        <div class="item">
          <div class="content">
            <div class="name">{{ $t('message.domesticDeliveryInProgress') }}</div>
            <div class="num">{{ statsData.domesticDeliveryCount }}{{ $t('message.strip') }}</div>
          </div>
        </div>
      </router-link>
      <!-- 问题产品 -->
      <router-link :to="'/pre-saleProblem?user_id=' + this.user_id" target="_blank">
        <div class="item">
          <div class="content">
            <div class="name">{{ $t('message.Problem') }}</div>
            <div class="num">{{ statsData.problemCount }}{{ $t('message.strip') }}</div>
          </div>
        </div>
      </router-link>
      <!-- 售后信息 -->
      <router-link :to="'/afterSale?user_id=' + this.user_id" target="_blank">
        <div class="item">
          <div class="content">
            <div class="name">{{ $t('message.afterSalesInformation') }}</div>
            <div class="num">{{ statsData.afterSaleCount }}{{ $t('message.strip') }}</div>
          </div>
        </div>
      </router-link>
      <!-- 出入金记录 -->
      <router-link
        :to="'/user/detailsOfIncomingAndOutgoingFunds?userID=' + this.user_id + '&encryption=' + $md5(this.user_id + '')"
        target="_blank">
        <div class="item">
          <div class="content">
            <div class="name">{{ $t('message.depositAndWithdrawalRecords') }}</div>
            <div class="num">{{ statsData.billCount }}{{ $t('message.strip') }}</div>
          </div>
        </div>
      </router-link>
      <!-- 发票记录 -->
      <router-link :to="'/porderShipped?user_id=' + this.user_id" target="_blank">
        <div class="item">
          <div class="content">
            <div class="name">{{ $t('message.invoiceRecord') }}</div>
            <div class="num">{{ statsData.invoiceCount }}{{ $t('message.strip') }}</div>
          </div>
        </div>
      </router-link>
      <!-- 注意事项 -->
      <router-link :to="'/user/basicInformation?userID=' + this.user_id + '&encryption=' + $md5(this.user_id + '')"
        target="_blank">
        <div class="item">
          <div class="content">
            <div class="name">{{ $t('message.mattersNeedingAttention') }}</div>
            <div class="num">{{ statsData.noticeCount }}{{ $t('message.strip') }}</div>
          </div>
        </div>
      </router-link>
      <!-- 操作日志 -->
    </div>
    <!-- 数据展板 -->
    <h3>
      {{ $t('message.dataDisplayBoard') }}
      <el-date-picker v-model="time" type="year" @change="setData" value-format="yyyy">
      </el-date-picker>
    </h3>
    <!-- 数据面板 -->
    <div class="dataDisplayBoard">
      <div class="item">
        <echarts :option="datas.lineOption" v-if="datas.lineShow" />
      </div>
      <div class="item">
        <echarts :option="datas.pieOption" v-if="datas.pieShow" />
      </div>

    </div>
    <!-- 客户动态 -->
    <h3>
      {{ $t('message.customerDynamics') }}
    </h3>
    <div class="table">
      <ul v-for="(item, index) in dynamics" :key="index">
        <li class="flex05">{{ $t('message.user') }}</li>
        <li>{{ item.realname }}</li>
        <li>{{ item.time_node }}</li>
        <li style="justify-content: left;" class="flex6">{{ item.content }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { getDate, lessThanAMonth } from '@/utlis/date'
import { pieOption, option } from '@/utlis/echartsOption'
export default {
  data() {
    return {
      pieOption,
      option,

      time: new Date().getFullYear().toString(), // 默认显示当前年份
      user_id: this.$route.query.userID,
      dynamics: [], // 动态
      statsData: {}, //统计客户历史信息
      disburseData: {
        user_id: this.$route.query.userID,
        start_time: '',
        end_time: '',
      },

      datas: {
        pieShow: false,
        lineShow: false,
        pieOption: {},
        lineOption: {},
      },

    };
  },
  created() {
    console.log(new Date().getFullYear());

    this.userStats()
    this.customerDynamics()
    this.consumptionRatio()
    this.disburseAmount()
  },
  methods: {
    // 相关信息
    userStats() {
      this.$api.clienteleApi.userStats({ user_id: this.user_id }).then((res) => {
        this.statsData = res.data
      });
    },
    // 客户动态
    customerDynamics() {
      this.$api.clienteleApi.customerDynamics({ user_id: this.user_id }).then((res) => {
        this.dynamics = res.data
      });
    },
    // 消费金额图表
    consumptionRatio() {
      if (this.time) {
        this.disburseData.start_time = this.time + '-01-01'
        this.disburseData.end_time = this.time + '-12-31'

      }

      this.$api.clienteleApi.consumptionRatio(this.disburseData).then((res) => {
        this.setPieEcharts(res.data)
      });
    },
    // 消费金额图表
    disburseAmount() {
      if (this.time) {
        this.disburseData.start_time = this.time + '-01-01'
        this.disburseData.end_time = this.time + '-12-31'

      }
      this.$api.clienteleApi.disburseAmount(this.disburseData).then((res) => {
        this.setLineEcharts(res.data)
      });
    },
    // 饼图
    setPieEcharts(data) {
      this.datas.pieOption = JSON.parse(JSON.stringify(this.pieOption)) // 复制模板
      this.datas.pieOption.legend = {
        orient: 'vertical',
        right: 10,
        bottom: 10,
        data: [],
        icon: 'circle',
      }
      this.datas.pieOption.tooltip.formatter = '{a} <br/>{b}: {c} ({d}%)'
      this.datas.pieOption.series = [
        {
          name: '消费比率',
          type: 'pie',
          radius: ['50%', '85%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: true,
              color: '#4c4a4a',
            },
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '30',
              fontWeight: 'bold'
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          labelLine: {
            show: true
          },
          data: []
        }
      ]
      // let itemData = this.datas.data.find(item => item.k == this.datas.years)

      data.forEach((item, i) => {
        this.datas.pieOption.legend.data.push(item.name)
        this.datas.pieOption.series[0].data.push(
          { value: item.value, name: item.name },
        )
      })
      this.datas.pieShow = true
    },
    // 折线图
    setLineEcharts(data) {
      this.datas.lineOption = {
        title: {

        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [],
          icon: 'circle',
          left: '0%',
          top: 0
        },
        grid: {
          left: '0%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: "#999" }, show: false },
          show: true
        },
        series: [

        ]
      }
      data.forEach(item => {
        this.datas.lineOption.legend.data.push(item.amount_tupe)
        let itemData = {
          name: item.amount_tupe,
          type: 'line',
          // stack: 'Total',
          data: []
        }
        item.value.forEach(items => {
          itemData.data.push(items.value)
        })
        this.datas.lineOption.series.push(itemData)
      })
      data[0].value.forEach(item => {
        this.datas.lineOption.xAxis.data.push(item.date)
      })

      this.datas.lineShow = true
      this.$forceUpdate()
    },
    setData() {
      this.datas.pieShow = false
      this.datas.lineShow = false
      this.consumptionRatio()
      this.disburseAmount()
    },
  }
}
</script>
<style lang='scss' scoped>
h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 24px;
}

.relatedInformation {
  display: flex;
  flex-wrap: wrap;

  a {
    color: #036EB8;
  }

  .item {
    margin: 0 24px 24px 0;
    width: 200px;
    height: 100px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;


    .content {
      text-align: center;

      .name {
        font-size: 16px;
      }

      .num {
        margin-top: 5px;
        color: #b4272d;
      }
    }
  }
}

.table {
  padding: 24px;
  border: 1px solid #ccc;
  border-radius: 5px;
  max-height: 500px;
  overflow-y: auto;

  .flex05 {
    flex: 0.5;
  }

  .flex6 {
    flex: 2;
  }
}

.dataDisplayBoard {
  display: flex;

  .item {
    flex: 1;
  }
}
</style>